export default __webpack_public_path__ + "static/media/NewArrival.85a10a0e.png";